import { SessionListener } from './SessionListener.mjs';
export { SESSION_START_EVENT, SESSION_STOP_EVENT } from './constants.mjs';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const sessionListener = new SessionListener();

export { sessionListener };
//# sourceMappingURL=index.mjs.map
